'use client'
import { CardText } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

const InfoMarketDataListError = () => {
  return (
    <div className="gap-sm flex flex-col">
      <CardText height="123px" text="An error occurred." withBorder />
    </div>
  )
}

export default memo(InfoMarketDataListError)
